import { render } from "./mobile-controls.vue?vue&type=template&id=d6318732"
import script from "./mobile-controls.vue?vue&type=script&lang=js"
export * from "./mobile-controls.vue?vue&type=script&lang=js"

import "./mobile-controls.vue?vue&type=style&index=0&id=d6318732&land=less&lang=css"

import exportComponent from "/Users/liuyansong/Work/Vue/test/vue3-video-player/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__